export namespace GEnum {
  //
  export enum Template {
    Default = 1,
    FullWidth = 2,
  }

  export enum ErrorCategory {
    None = 0,
    GrowApi = 1,
    AcademicApi = 2,
    AuthApi = 3,
  }

  // 評価タイプ
  export enum EvalProgress {
    Pending = 0,
    Progressing = 1,
    Completed = 2,
  }

  // コンピテンシータイプ

  // 教員権限
  export enum Role {
    Admin = 1,
    Normal = 2,
    IgsAdmin = 99,
  }

  // 追加サービスプランタイプ
  export enum AdditionalPlanType {
    TrendCheckAcademic = 1,
    TrendCheckAcademicReadOnly = 2,
  }

  // コンピテンシータイプ
  export enum CompetencySettingType {
    Recommend = 1,
    Full = 2,
    Customize = 3,
    Mini = 4,
    Uchida = 5,
  }

  // APIのレスポンス結果に対する通知メッセージタイプ
  export enum MessageType {
    Info = 1,
    Success = 2,
    Warn = 3,
    Error = 4,
  }

  // 受検ステータス
  export enum ExamStatus {
    BeforeStart = 0,
    UnderExamination = 1,
    EndOfExamination = 2,
  }

  // 生徒検索の絞り込みパラメータ(APIのパラメータに合わせた名前)
  export enum TargetType {
    None = 0,
    Class = 1,
    Grade = 2,
  }

  // 成長目的
  export enum GrowingPurpose {
    LeaderShip = 1,
    Innovation = 2,
    CriticalThinking = 3,
    CreativeThinking = 4,
    CollaborationThinking = 5,
  }

  // 2値のラジオボタンの値ラベル(iviewではradioボタンでboolean値を直接扱えないため使用する)
  export enum RadioLabel {
    False = 0,
    True = 1,
  }

  // 受検作成画面の受検者による評価リクエスト許可区分
  export enum EvaluationRequestPermissionCategory {
    PermitOnlySameCourseStudents = 1, // 許可する（同一受検コースのみ）
    PermitOnlySameSchoolStudents = 2, // 許可する（校内の登録者）
    PermitContainGuest = 4, // 許可する（ゲスト含む）
    NotPermit = 3, // 許可しない
  }

  // レポート表示種別(受検画面にて、表示させるフィードバックレポートの種別)
  export enum PersonalReportDisplayType {
    NoShow = 0, // ドロップダウン用フィードバックレポートを出力しない。DBに登録しない。
    SelfGrowthSupport = 1, // 自己成長支援版
    DiscoverStrengths = 2, // 強み発見版
  }

  // 評価者追加モーダルの評価者の対象範囲
  export enum EvaluatorScopeType {
    SameCourseStudents = 1, // 同一受検コースの生徒
    SameSchoolStudents = 2, // 校内の生徒
  }

  // 受検対象者分類タイプ
  export enum ExamineeSelectionType {
    Class = 1,
    Student = 2,
  }

  // 受検画面の編集モード
  export enum EvalSettingMode {
    Create = 1,
    Edit = 2,
    Copy = 3,
    Detail = 4,
  }

  // 受検作成ステップ
  export enum ExamCreateStep {
    BaseSettingStep = 0,
    QuestionSettingStep = 1,
    ExamineeSettingStep = 2,
    MailSettingStep = 3,
    ConfirmViewStep = 4,
  }

  // 受検作成ステップ
  export enum ExamCreateStepWithoutGiftCourseMail {
    BaseSettingStep = 0,
    QuestionSettingStep = 1,
    ExamineeSettingStep = 2,
    ConfirmViewStep = 3,
  }

  // 進級or初期設定ステップ
  export enum IntroductionStep {
    StepOneSchoolClassSetting = 0,
    StepTwoTeacherSetting = 1,
    StepThreeStudentSetting = 2,
    StepFourCompleted = 3,
  }

  // HTTP ステータスコード
  export enum HttpStatus {
    OK = 200,
    BadRequest = 400,
  }

  // ZIPフィードバックレポート 生成ステータス
  export enum ReportStatus {
    NoCompleted = -1,
    NoRequest = 0,
    Requesting = 1,
    Creating = 2,
    Completed = 3,
    CreateError = 99,
  }

  export enum StatusProgress {
    NoCompleted = 1,
    Completed = 2,
  }

  export enum IatOrSelfProgress {
    NoCompleted = 0,
    Completed = 1,
  }

  export enum GiftProgress {
    NoCompleted = 0,
    Completed = 2,
  }

  export enum EvaluatorGiftProgress {
    NoCompleted = 1,
    Completed = 2,
  }

  export enum TrendProgress {
    NoCompleted = 0,
    Completed = 1,
  }

  export enum ColorType {
    Red = 1,
    Blue = 2,
    Green = 3,
    Purple = 4,
    Orange = 5,
  }

  // コンピテンシー分布(棒グラフ)の絞り込みタイプ
  export enum ScaleType {
    SchoolClass = 1,
    Grade = 2,
    School = 3,
  }

  export enum ChartType {
    CompetencyBoxplot = 0,
    OtherCompetencyBoxplot = 1,
    CustomCompetencyBoxplot = 2,
    MVPlotCompetency = 3,
    MVPlotStudent = 4,
    CompetencyGrowthChart = 5,
    CharacterMapping = 6,
    CharacterBoxplot = 7,
    Network = 8,
  }

  export enum TrendAnalysisChartType {
    GrowthMindsetMap = 0,
    PsychologicalSafety = 1,
    HumanitiesOrSciences = 2,
  }

  export enum SurveyAnalysisChartType {
    AnswerBarGraph = 0,
    MetaAwarenessGrowth = 1,
    CompetencyBoGrowth = 2,
  }

  // 評価者の分類
  export enum EvaluatorType {
    Internal = 1,
    Outside = 2,
  }

  export enum Big5 {
    ID1 = 1, // 外向性-内向性
    ID2 = 2, // 開放性-保守性
    ID3 = 3, // 繊細性-平穏性
    ID4 = 4, // 協調性-独立性
    ID5 = 5, // 誠実性-快楽性
  }

  // クラス編成画面のD&D状態
  export enum DragState {
    Fixed = 1, // 変更なし状態
    Selected = 2, // 選択状態
    Changed = 3, // 変更状態
    Checked = 4, // 確定状態
  }

  // 生徒カルテタブ
  export enum KarteTab {
    TabProfile = 0,
    TabGrowth = 1,
    TabInterviewNavi = 2,
    TabCompetencySummary = 3,
    TabTrends = 4,
    TabFindingsProposals = 5,
    TabRecommendationLetter = 6,
  }

  export enum Trend {
    MasterID18 = 18, // 自分好感度チェック
    MasterID19 = 19, // 居心地度チェック
    MasterID20 = 20, // ねばり強さチェック
    MasterID21 = 21, // 文理傾向チェック
    MasterID23 = 23, // 自分好感度チェック（小学生）
    MasterID24 = 24, // 居心地度チェック（小学生）
    MasterID25 = 25, // ねばり強さチェック（小学生）
    MasterID30 = 30, // 自分好感度チェック（低学年）
    MasterID31 = 31, // 居心地度チェック（低学年）
    MasterID32 = 32, // ねばり強さチェック（低学年）
  }

  export enum AllCompetencyGraphTab {
    TabDistributionChart = 0,
    TabGrowthChart = 1,
    TabFunChart = 2,
    TabCompareScore = 3,
  }

  // クラス編成画面のD&Dの領域タイプ
  export enum DragAreaType {
    TypeWorkSpace = 0,
    TypeDeleteSpace = 1,
    TypeSchoolClass = 2,
  }

  // コンピテンシータイプ
  export enum CompetencyType {
    Cognitive = 1,
    Self = 2,
    Gift = 3,
    Community = 4,
  }

  // グルーピングタイプ(調和、多様性)
  export enum GroupType {
    Harmony = 1,
    Diversity = 2,
  }

  // 評価リクエストをランダム生成するの生徒の領域タイプ
  export enum TargetDomainType {
    SchoolClass = 1,
    Grade = 2,
    Tag = 3,
    All = 4,
    PriorityTag = 5,
  }

  // コンピテンシーID
  export enum Competency {
    ID1 = 1, //課題設定
    ID2 = 2, //解決意向
    ID3 = 3, //個人的実行力
    ID4 = 4, //創造性
    ID5 = 5, //論理的思考
    ID6 = 6, //疑う力
    ID7 = 7, //内的価値
    ID8 = 8, //ヴィジョン
    ID9 = 9, //自己効力
    ID10 = 10, //成長
    ID11 = 11, //興味
    ID12 = 12, //耐性
    ID13 = 13, //感情コントロール
    ID14 = 14, //表現力
    ID15 = 15, //共感・傾聴力
    ID16 = 16, //外交性
    ID17 = 17, //柔軟性
    ID18 = 18, //決断力
    ID19 = 19, //寛容
    ID20 = 20, //影響力の行使
    ID21 = 21, //情熱・宣教力
    ID22 = 22, //組織への働きかけ
    ID23 = 23, //地球市民
    ID24 = 24, //組織へのコミットメント
    ID25 = 25, //誠実さ
  }

  // その他のコンピテンシー表示用のID
  export enum BoxplotOtherCompetencyID {
    Individuality = 1001, //主体性
    Collaboration = 1002, //協働性
    Leadership = 1003, //リーダーシップ
    Innovation = 1004, //イノベーション
    CriticalThinking = 1005, //批判的思考力
    CreativeThinking = 1006, //創造的思考力
    CollaborativeThinking = 1007, //協働的思考力
  }

  // 生徒カルテの学力の三要素コンピテンシー表示用のID
  export enum AcademicAbilityElements {
    Thinking = 1001, //思考力（論理的思考）
    Decisiveness = 1002, //判断力（決断力）
    Expression = 1003, //表現力
    Individuality = 1004, //主体性
    Collaboration = 1005, //協働性
    Flexibility = 1006, //多様性（柔軟性）
  }

  // 同姓同名チェックの種別
  export enum DuplicateNameCheckType {
    // 姓名でチェック
    Name = 1,
    // 姓名（フリガナ）でチェック
    NameKana = 2,
  }

  // 生徒一覧のsortKey
  export enum StudentSortKey {
    StundentNumber = 1,
    FullName = 2, // 現在廃止
    Grade = 3,
    Class = 4,
    ManageNumber = 5,
  }

  // sortType(昇順or降順)
  export enum SortType {
    Asc = 1,
    Desc = -1,
  }

  // 設問タイプ
  export enum QuestionTypes {
    OneTypes = 1, // Ⅰ類（従来の中高版）
    Debate = 2, // ディベート
    BusinessHigh = 3, // 実業高校
    CulturalAthletic = 4, // 文化祭・体育祭
    HighSchoolL = 5, // 高校L
    Primary = 6, // 小学校
    PrimaryL = 7, // 小学校L
    GeneralUniversity = 8, // 一般(大学)
    GeneralPrimary = 9, // 一般(小学校)
    TwoTypes = 10, // Ⅱ類（平易な表現版）
  }

  // 傾向チェック項目
  export enum TrendCheck {
    DigitalReal = 1, // デジタルーリアル
    FuturePast = 2, // 未来ー過去
    CompletionProcess = 3, // 完了ー過程
    Game1 = 4, // Game1
    Game2 = 5, // Game2
    Game3 = 6, // Game3
    DigitalRealVerification = 7, // デジタルーリアル検証
    VerificationA = 8, // 検証A
    VerificationB = 9, // 検証B
    StressCheck = 10, // ストレスチェック
    LonelinessTolerance = 11, // 孤独感への耐性測定
    ResultfProcessf = 12, // 結果重視ープロセス重視
    HardWork = 13, // ハードワーク資質測定
    RiskTolerance = 14, // リスク許容度測定
    MaleAndFemale = 15, // 男性ー女性
    ManagerGeneral = 16, // 基幹職ー一般職
    StabilityChallenge = 17, // 安定ーチャレンジ
    SelfLiking = 18, // 自分好感度チェック
    ComfortLevel = 19, // 居心地度チェック
    Toughness = 20, // ねばり強さチェック
    LiteraryTendency = 21, // 文理傾向チェック
    ManAndWoman = 22, // 男女
    SelfLikingP = 23, // 自分好感度チェック（小学生）
    ComfortLevelP = 24, // 居心地度チェック（小学生）
    ToughnessP = 25, // ねばり強さチェック（小学生）
    ShortenedForVerification = 26, // 検証用短縮問題
    SelfEsteem = 27, // 自己肯定感
    SelfEfficacy = 28, // 自己効力感
    DxTraditional = 29, // DX的-伝統的
    SelfLikingPLower = 30, // 自分好感度チェック（低学年）
    ComfortLevelPLower = 31, // 居心地度チェック（低学年）
    ToughnessPLower = 32, // ねばり強さチェック（低学年）
  }

  // JGROW - コンピテンシータイプ
  export enum JgrowCompetencySettingType {
    Basic = 1,
    Custom = 2,
  }

  // 受検画面の編集モード
  export enum JgrowEventPageMode {
    Create = 1,
    Edit = 2,
    Detail = 4,
  }

  // アンケートの事前・事後タイプ
  export enum SurveysType {
    Before = 1,
    After = 2,
  }

  // 画面制御タイプ（内田洋行）
  export enum DispCtrlType {
    Normal = 1,
    Uchida = 2,
  }

  // コンピテンシースコア（相互評価）の評価を受けた（完了した）数
  export enum GiftRequestScoreStatus {
    NotMeasured = 0, // 未計測（誰も評価を完了させていない）
    Estimated   = 1, // 試算値（1人完了）
    Reference   = 2, // 参考値（2人完了）
    Determined  = 3, // 確定値（3人以上完了）
  }
}
